export class Firma_Electronica_CamposAdicionalesDatos {
    codigo: string;
    descripcion: string;
    codigoDependiente: string;
}